<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
            class="box"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="code"
                    label="编号"
                    prop="code"
                    :help="formErr.code"
                    :validateStatus='!formErr.code||formErr.code==""?"":"error"'
            >
                <a-input
                        :maxLength=50
                        v-model="form.code"
                        @change="(e) => { formErr.code=''}"
                        @blur="(e) => {  form.code = e.target.value.trim();}"
                />
            </a-form-model-item>

            <a-form-model-item
                    ref="color"
                    label="颜色"
                    prop="color"
                    :help="formErr.color"
                    :validateStatus='!formErr.color||formErr.color==""?"":"error"'
            >
                    <a-checkbox-group v-model="form.color">
                        <a-checkbox :value="item.id" v-for="(item, idx) in this.color_list" :key="idx">
                            {{item.name}}
                        </a-checkbox>
                    </a-checkbox-group>
            </a-form-model-item>
          <a-form-model-item
                    ref="a_ksh_industry_id"
                    label="行业"
                    prop="a_ksh_industry_id"
                    :help="formErr.a_ksh_industry_id"
                    :validateStatus='!formErr.a_ksh_industry_id||formErr.a_ksh_industry_id==""?"":"error"'
            >

            <a-select v-model="form.a_ksh_industry_id" class="seachs" allowClear @keydown.enter.native="searchKey" >
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in industry_list">
                {{item.name}}
              </a-select-option>
            </a-select>
            </a-form-model-item>
          <a-form-model-item
                    ref="is_safety_range"
                    label="安全范围是否可调"
                    prop="is_safety_range"
                    :help="formErr.is_safety_range"
                    :validateStatus='!formErr.is_safety_range||formErr.is_safety_range==""?"":"error"'
            >

            <a-select v-model="form.is_safety_range" class="seachs"   >
              <a-select-option :value="1" >是</a-select-option>
              <a-select-option :value="2" >否</a-select-option>
            </a-select>
            </a-form-model-item>


          <a-form-model-item v-if="form.id"
              ref="picture"
              label="默认图片"
              prop="picture"
              :extra="formErr.picture"
              :validateStatus='!formErr.picture||formErr.picture==""?"":"error"'
          >
            <a-upload
                :action="this.$store.state.urlChang"
                :data="{type:3}"
                :file-list="fileList"
                :headers="headers"
                @change="(file)=>{handleChange(file,1)}"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                list-type="picture-card"
                name="file"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus"/>
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
              <img :src="previewImage" alt="example" style="width: 100%"/>
            </a-modal>
          </a-form-model-item>
          <a-form-model-item
              ref="status"
              label="状态"
              prop="status"
              :extra="formErr.status"
              :validateStatus='!formErr.status||formErr.status==""?"":"error"'
          >
            <a-radio-group v-model="form.status"  >
              <a-radio :value="item.id" v-for="(item, idx) in this.status_list" :key="idx"> {{item.name}} </a-radio>

            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              ref="is_proxy"
              label="代理模板"
              prop="is_proxy"
              :extra="formErr.is_proxy"
              :validateStatus='!formErr.is_proxy||formErr.is_proxy==""?"":"error"'
          >
            <a-radio-group v-model="form.is_proxy"  >
              <a-radio :value="item.id" v-for="(item, idx) in this.proxy_list" :key="idx"> {{item.name}} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              ref="is_popup"
              label="网站弹框"
              prop="is_popup"
              :extra="formErr.is_popup"
              :validateStatus='!formErr.is_popup||formErr.is_popup==""?"":"error"'
          >
            <a-radio-group v-model="form.is_popup"  >
              <a-radio :value="item.id" v-for="(item, idx) in this.popup_list" :key="idx"> {{item.name}} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="!form.id"
              ref="nav_type"
              label="导航类型"
              prop="nav_type"
              :extra="formErr.nav_type"
              :validateStatus='!formErr.nav_type||formErr.nav_type==""?"":"error"'
          >
            <a-radio-group v-model="form.nav_type"  >
              <a-radio :value="item.id" v-for="(item, idx) in this.nav_type_list" :key="idx"> {{item.name}} </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item
              ref="designer_id"
              label="设计师"
              prop="designer_id"
              :help="formErr.designer_id"
              :validateStatus='!formErr.designer_id||formErr.designer_id==""?"":"error"'
          >

            <a-select v-model="form.designer_id" class="seachs" allowClear >
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in designer_list">
                {{item.name}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
               ref="nav_type"
               label="模板类型"
               prop="type"
               :extra="formErr.type"
               :validateStatus='!formErr.type||formErr.type==""?"":"error"'
          >
            <a-radio-group v-model="form.type">
              <a-radio :value="item.id" v-for="(item, idx) in this.type_list" :key="idx"> {{item.name}} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
              v-if="form.type==2"
              ref="customized_customer_id"
              label="定制客户"
              prop="customized_customer_id"
              :help="formErr.customized_customer_id"
              :validateStatus='!formErr.customized_customer_id||formErr.customized_customer_id==""?"":"error"'
          >

            <a-select v-model="form.customized_customer_id" class="seachs" allowClear show-search :filter-option="filterOption">
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in customized_customer_list">
                {{item.name}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
import {submitForm, drawerConfig, validator, beforeUpload, createUrl} from "../../../../utils/utils"
    import API from "../api";
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        name: "templateForm",
        props: ["visible","title","editId",'createId'],
        data() {


            return {
                drawerConfig ,
              industry_list:[],
              color_list:[],
              status_list:[],
              proxy_list:[],
              popup_list:[],
              nav_type_list:[],
              designer_list:[],
              type_list: [],
              customized_customer_list: [],
              fileList:[],
                previewVisible: false,
                previewImage: "",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                form: {
                  code:"",
                  color:[],
                  a_ksh_industry_id:"",
                  status:4,
                  is_proxy:2,
                  is_popup:2,
                  nav_type:1,
                  is_safety_range:2,
                  picture:'',
                  designer_id: '',
                  type: 1,
                  customized_customer_id: ''
                },
                formErr: {
                  code:"",
                  color:'',
                  a_ksh_industry_id:"",
                  status:"",
                  is_proxy:"",
                  is_popup:"",
                  nav_type:"",
                  is_safety_range:"",
                  picture:'',
                  designer_id: '',
                  customized_customer_id: ''
                },
            // {required: true, message: "请输入首页内容", trigger: "blur"},{ whitespace: true, message: "请输入首页内容 " },
            rules: {
                    code: [{required: true, message: "请输入模板编号", trigger: "blur"}, { whitespace: true, message: "请输入模板编号 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.code)}  , trigger: "blur"  },],
              color: [{required: true, message: "请选择颜色", trigger: "change"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.color)}  , trigger: "blur"  },],
              a_ksh_industry_id: [{required: true, message: "请选择行业", trigger: "change"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.a_ksh_industry_id)}  , trigger: "blur"  },],
              is_safety_range: [{required: true, message: "请选择安全范围是否可填", trigger: "change"} ],
              designer_id: [{required: true, message: "请选择设计师", trigger: "change"} ],
              customized_customer_id: [{required: true, message: "请选择定制客户", trigger: "change"} ],
            },
                layout: {
                    labelCol: { span:6},
                    wrapperCol: { span: 14 },
                },
            };



        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                      this.industry_list=res.data.data.industry_list
                      this.color_list=res.data.data.color_list
                      this.status_list=res.data.data.status_list
                      this.proxy_list=res.data.data.proxy_list
                      this.popup_list=res.data.data.popup_list
                      this.nav_type_list=res.data.data.nav_type_list
                      this.designer_list=res.data.data.designer_list
                      this.type_list=res.data.data.type_list
                      this.customized_customer_list=res.data.data.customized_customer_list
                      this.form = {
                        ...res.data.data.info,
                        customized_customer_id: res.data.data.info.customized_customer_id==0?'':res.data.data.info.customized_customer_id,
                      }
                        if (this.form.picture == "") {
                            this.fileList = []
                        } else {
                            this.fileList = [
                                {uid: this.form.picture,
                                 name: this.form.picture,
                                 status: "done",
                                 url: this.form.picture ? this.form.picture : ""
                                }
                            ]
                        }


                        this.form.id=a
                    })
                } else {
                  API.service.ADD_DATA(a).then(res => {
                    this.industry_list=res.data.data.industry_list
                    this.color_list=res.data.data.color_list
                    this.status_list=res.data.data.status_list
                    this.proxy_list=res.data.data.proxy_list
                    this.popup_list=res.data.data.popup_list
                    this.nav_type_list=res.data.data.nav_type_list
                    this.designer_list=res.data.data.designer_list
                    this.type_list=res.data.data.type_list
                    this.customized_customer_list=res.data.data.customized_customer_list
                    this.form.id = ''
                  })
                    this.form.id = ''
                }
            }
        },
        mounted(){
            // this.getFormData()
        },
        methods: {
          // getFormData(){
          //     API.service.ADD_DATA().then(res => {
          //         this.seleList=res.data.data
          //     })
          // },
            filterOption(input, option) {
              return (
                  option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
              )
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handleChange(info ,type) {
                // alert(type)
                let {fileList} = info;
                const status = info.file.status;
                if (status !== 'uploading') {
                    type==1?this.fileList=[]:this.fileListSmall=[]
                }
                if (status === 'done') {
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                    // this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                    // this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        // this.formErr.picture=""
                        // this.fileList= fileList
                    });
                    if(type==1){
                        this.formErr.picture=""
                    }else {
                        this.formErr.thumb_small=""
                    }
                    type==1?this.fileList=fileList:this.fileListSmall=fileList
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
                return beforeUpload(file,5)
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            onClose() {
                this.$emit("changVisible", false);
                this.fileList=[]
                this.fileListSmall=[],
                this.formErr={
                  code:"",
                  color:[],
                  a_ksh_industry_id:"",
                  status:'',
                  is_proxy:'',
                  is_popup:'',
                  nav_type:'',
                  picture:''
                }
              this.form={
                code:"",
                    color:[],
                    a_ksh_industry_id:"",
                    status:4,
                    is_proxy:2,
                    is_popup:2,
                    nav_type:1,
                    picture:'',
                    type: 1,
                    customized_customer_id: ''
              },
                this.$refs.ruleForm.resetFields();
            },
            submitSuccess() {
              this.$emit("addTemplateSucc", this.form);
              this.fileList=[]
              this.fileListSmall=[],
              this.formErr={
                code:"",
                color:[],
                a_ksh_industry_id:"",
                status:'',
                is_proxy:'',
                is_popup:'',
                nav_type:'',
                picture:''
              }
              this.form={
                code:"",
                color:[],
                a_ksh_industry_id:"",
                status:4,
                is_proxy:2,
                is_popup:2,
                nav_type:1,
                picture:''
              }
              this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                if (this.fileList.length < 1) {
                    // _this.formErr.picture = "请选择可视化图片";

                } else {
                    _this.formErr.picture = "";
                    this.form.picture = this.fileList[0].url
                }


                if (this.fileList.length > 0 && this.fileList[0].url) {
                    this.form.picture = this.fileList[0].url
                } else if (this.fileList.length > 0 && this.fileList[0].response) {
                    this.form.picture = this.fileList[0].response.data.url
                } else {
                    this.form.picture = ""
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                      if(this.createId) this.form.id =this.createId
                        submitForm(url, _this.form).then(res => {
                          console.log("res",res)
                            if (res == true) {
                                this.submitSuccess()
                                if(url === API.service.SUBMIT_ADD&&!this.createId){
                                  window.open(createUrl(window.tempData.data.ksh_token, window.tempData.data.id, 'template'),'_blank')
                                }
                            } else {
                              if(this.createId) this.form.id =undefined
                              res.map((item, index) => {
                                   this.formErr[item.field] = item.msg
                               })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 10px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
.box >>> .ant-checkbox-wrapper + .ant-checkbox-wrapper{margin-left: 0}
/*.box >>> .ant-form-extra*/
</style>
